import { apiAddress } from "../../config/server";
import { ApiBase } from "./baseApi";

export enum BlockedReason {
  bounced = "bounced",
  spam = "spam",
  abuse = "abuse",
  manual = "manual",
}

export interface IVerifiedEmail {
  _id: string;
  email: string;
  person: string;
  dateCreated: Date;
  dateVerified: Date;
  archived: boolean;
  blockedDate?: Date;
  blockedReason?: BlockedReason;
}

export namespace BlockedReason {
  export function toString(reason: BlockedReason) {
    switch (reason) {
      case BlockedReason.abuse:
        return "Abuse of this email address was detected.";
      case BlockedReason.bounced:
        return "Emails were never delivered. This could be due to a typo or the email address no longer existing.";
      case BlockedReason.spam:
        return "Emails were externally marked by spam.";
      case BlockedReason.manual:
        return "This email address was manually blocked by clicking a ban link in an email.";
      default:
        return "Unknown reason";
    }
  }
}

export enum CommunicationType {
  Rostered = "rostered",
}

export namespace CommunicationType {
  export const getAllTypes = () => [CommunicationType.Rostered];

  export const toString = (type: CommunicationType) => {
    switch (type) {
      case CommunicationType.Rostered:
        return "Rostering emails";
    }
  };
}

export default class CommunicationApi extends ApiBase {
  static ListAddress = `${apiAddress}/api/communication/emails`;

  static DeleteAddress = `${apiAddress}/api/communication/`;

  static AddAddress = `${apiAddress}/api/communication/createUnverified`;

  static getMyEmails(): Promise<IVerifiedEmail[]> {
    return this.get<IVerifiedEmail[]>(this.ListAddress).then(
      (resp) => resp.data.data,
    );
  }

  static addEmail(emailAddress: string) {
    return this.post(this.AddAddress, { email: emailAddress }).then(
      (resp) => resp.data.data,
    );
  }

  static archiveEmail(emailId: string) {
    return this.delete(this.DeleteAddress + emailId).then(
      (resp) => resp.data.data,
    );
  }
}
